<template>
  <div class="u_co_main">
    <h3>Liste des utilisateurs habilités</h3>

    <a-divider></a-divider>

    <a-list item-layout="horizontal" :data-source="users">
      <template #loadMore>
        <div
          :style="{
            textAlign: 'center',
            marginTop: '12px',
            height: '32px',
            lineHeight: '32px',
          }"
        >
          <a-button @click="addCoUser"
            >Ajouter une nouvelle habilitation</a-button
          >
        </div>
      </template>
      <template #renderItem="{ item }">
        <a-list-item>
          <template #actions>
            <!-- <a @click="editCoUser" key="list-loadmore-edit">Modifier</a>
            <a @click="activateCoUser" key="list-loadmore-more">Desactiver</a> -->
            <a @click="deleteCoUser(item.uuid)" key="list-loadmore-more"
              >Supprimer</a
            >
          </template>
          <a-list-item-meta :description="item.email">
            <template #title>
              {{ item.json_data?.first_name }}
              {{ item.json_data?.last_name }}
            </template>
            <template #avatar>
              <a-avatar>{{ item.json_data?.avatar }}</a-avatar>
            </template>
          </a-list-item-meta>
        </a-list-item>
      </template>
    </a-list>

    <br />
    <div v-if="add_form" class="ui divider"></div>
    <div v-if="add_form">
      <div>
        <div>
          <div>
            <label>Prénom</label>
            <a-input v-model:value="co.first_name" />
          </div>
          <div>
            <label>Nom</label>
            <a-input v-model:value="co.last_name" />
          </div>
        </div>
        <div class="three fields">
          <div>
            <label>Mail</label>
            <a-input type="email" v-model:value="co.email" />
          </div>
          <div>
            <label>Téléphone portable</label>
            <a-input v-model:value="co.mobile_phone" />
          </div>
          <div>
            <label>Téléphone fixe</label>
            <a-input v-model:value="co.fix_phone" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="add_form" style="text-align: right">
      <a-divider></a-divider>

      <a-button
        @click="cancelCo"
        style="color: red; border-color: red; margin-right: 20px"
        type="primary"
        shape="round"
        ghost
        >Annuler</a-button
      >
      <a-button @click="createCoUser" type="primary" shape="round" ghost
        >Valider</a-button
      >

      <a-divider></a-divider>
      <div style="color: red; text-align: center">
        <div v-for="(m, k) in errorMessages" :key="k">
          {{ m[0] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "docs",
  components: {},
  data: () => {
    return {
      editMode: false,
      page: "courtier",
      add_form: false,

      showMessage: false,
      messageText: "",

      showErrorMessage: false,
      errorMessages: "",

      changeWhat: "INFO",

      originalInfo: [],

      pass: {
        old: "",
        passOne: "",
        passTwo: "",
      },

      co: {
        id: null,
        email: "",
        first_name: "",
        last_name: "",
        mobile_phone: "",
        fix_phone: "",
      },
    };
  },
  watch: {},
  methods: {
    reset() {
      this.pass.old = "";
      this.pass.passOne = "";
      this.pass.passTwo = "";
    },
    cancel() {
      this.reset();
      this.editMode = false;
      this.changeWhat = "INFO";

      this.showMessage = false;
      this.showErrorMessage = false;

      this.courtier.adresse = this.originalInfo.adresse;
      this.courtier.adresse_suite = this.originalInfo.adresse_suite;
      this.courtier.cp = this.originalInfo.cp;
      this.courtier.ville = this.originalInfo.ville;
      this.courtier.tel_p = this.originalInfo.tel_p;
      this.courtier.tel_f = this.originalInfo.tel_f;
    },
    edit(what) {
      this.changeWhat = what;
      this.editMode = true;
    },
    save() {
      this.showErrorMessage = false;

      if (this.changeWhat == "PASS") {
      }

      this.axios
        .post("modifCourtier", {
          courtier: this.courtier,
          pass: this.pass,
          changeWhat: this.changeWhat,
        })
        .then((r) => {
          if (r.data.status == false) {
            this.showErrorMessage = true;
            this.errorMessages = r.data.errorMessage;
            return;
          }

          if (r.data.status == true) {
            this.showMessage = true;

            if (this.changeWhat == "INFO")
              this.messageText =
                "Votre demande sera traitée dans les meilleurs délais";
            if (this.changeWhat == "PASS")
              this.messageText = "Votre mot de passe a été modifié";

            this.editMode = false;
            this.changeWhat = "INFO";

            setTimeout(() => {
              this.showMessage = false;
            }, 5000);

            this.reset();
          }
        });
    },
    addCoUser() {
      this.errorMessages = "";

      this.co = new Object();

      this.co.id = null;
      this.co.email = "";
      this.co.first_name = "";
      this.co.last_name = "";
      this.co.mobile_phone = "";
      this.co.fix_phone = "";
      this.add_form = true;
    },
    createCoUser() {
      this.errorMessages = "";
      this.axios
        .post("data/cocourtier", this.co)
        .then((r) => {
          if (r.status == 201) {
            this.add_form = false;
            this.$store.state.coBrokers.push(r.data);
          }
        })
        .catch((r) => {
          this.errorMessages = r.response.data.errors;
        });
    },
    editCoUser(id) {
      this.users.filter((u) => {
        if (id == u.id) this.co = u;
      });
      this.add_form = true;
    },
    deleteCoUser(uuid) {
      var r = confirm("Êtes-vous sûr ?");
      if (r == true) {
        this.axios.delete("data/cocourtier/" + uuid).then((r) => {
          if (r.status == 200) {
            this.users.filter((u, k) => {
              if (uuid == u.uuid) this.users.splice(k, 1);
            });
          }
          if (r.data.status == false) {
            console.log("error");
          }
        });
      }
    },
    cancelCo() {
      this.add_form = false;
    },
  },
  computed: {
    courtier() {
      return this.$store.getters.broker;
    },
    isRootBroker() {
      return this.courtier.type === "ROOT";
    },
    users() {
      return this.$store.state.coBrokers;
    },
  },
  mounted() {
    Object.assign(this.originalInfo, this.courtier);
  },
};
</script>